import React, { Component } from "react";
import AntdDivider, {DividerProps} from 'antd/lib/divider';
import 'antd/lib/divider/style';

export default class Divider extends Component<DividerProps> {
    render() {
        return (
          <AntdDivider {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/divider/index.tsx